import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { LandmarksLocationsRoutes } from '../../../routes';

export const LandmarksLocationsLayout = () => (
  <>
    <SwitchRoute routes={LandmarksLocationsRoutes} />
  </>
);
